import {useCallback, useEffect, useState} from 'react';

export const useRunsPaging = (pageSize: number) => {
  // Paging works by setting the `limit` query variable, which determines
  // how many runs we get back. When the user clicks "next page" or selects
  // a larger page size, all we're really doing is setting a higher `limit`.
  const [limit, setLimit] = useState(pageSize);

  // To avoid triggering unnecessary requests when selecting a smaller page size
  // or visiting a page that only has runs we've already seen, we should only update
  // `limit` if the new value would be larger (and therefore include new results).
  const setLimitMax = (potentialLimit: number) => {
    setLimit(curLimit => Math.max(curLimit, potentialLimit));
  };

  // This is called when user pages forward
  const loadMoreRuns = useCallback(
    (page: number) => setLimitMax(page * pageSize),
    [pageSize]
  );

  // Make sure `limit` is up to date if page size changes
  useEffect(() => {
    setLimitMax(pageSize);
  }, [pageSize]);

  return {limit, loadMoreRuns};
};
